import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';

import { BreadcrumbItemProps } from '../../../shared/components/Breadcrumbs/BreadcrumbItem/BreadcrumbItem';
import CustomEmptyPage from '../../../shared/components/CustomEmptyPage/CustomEmptyPage';
import PageCurvedContainer from '../../../shared/components/PageCurvedContainer/PageCurvedContainer';
import { RewardsContext } from '../../../shared/context/rewards/rewardsContext';
import { TRANSLATION_POINTS } from '../../../shared/translations/rewards';
import { TRANSLATIONS_SETTINGS } from '../../../shared/translations/settings';
import RewardsPageHeader from '../sections/RewardsPageHeader/RewardsPageHeader';
import RewardsPointsTabBar from '../sections/RewardsPointsTabBar/RewardsPointsTabBar';
import SendPoints from './sections/SendPoints/SendPoints';

const RewardsPoints = () => {
  const { balance, currency, loading: rewardsLoading, error: rewardsError } = useContext(RewardsContext);
  const { t } = useTranslation();

  const pointsBreadcrumb: BreadcrumbItemProps[] = [
    { label: t(TRANSLATION_POINTS.header.breadcrumb.rewards) },
    { label: t(TRANSLATION_POINTS.header.breadcrumb.sendPoints) }
  ];

  return (
    <div className="page-container curved" data-experience="new">
      <RewardsPageHeader
        breadcrumbs={pointsBreadcrumb}
        rewardsLoading={rewardsLoading}
        rewardsError={rewardsError}
        currency={currency}
        balance={balance}
        title={t(TRANSLATION_POINTS.header.title)}
        description={t(TRANSLATION_POINTS.header.description)}
        button={true}
      />
      <PageCurvedContainer>
        {rewardsError ? (
          <CustomEmptyPage
            title={t(TRANSLATIONS_SETTINGS.error.title)}
            subtitle={t(TRANSLATIONS_SETTINGS.error.subtitle)}
            newExperience={true}
          />
        ) : (
          <>
            <RewardsPointsTabBar />
            <SendPoints />
          </>
        )}
      </PageCurvedContainer>
    </div>
  );
};

export default RewardsPoints;
